import React from "react";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";
import "../notfound/notfound.scss"
import { Link } from "react-router-dom";

const NotFound = () => {

    return (
        <div className="notfound">
            <Helmet>
                <title>Error 404 | Jakob Augschöll</title>
            </Helmet>
            <div className="container">
                <motion.h2
                    initial={{ opacity: 0, y: 10 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, ease: "easeOut" }}
                >
                    Error 404
                </motion.h2>
                <motion.h3
                    initial={{ opacity: 0, y: 10 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, ease: "easeOut", delay: 0.25 }}
                >
                    Hallo, nett hier?
                </motion.h3>
                <motion.p
                    initial={{ opacity: 0, y: 10 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, ease: "easeOut", delay: 0.5 }}
                >
                    Jedoch ist diese Seite leider nicht mehr verfügbar oder du hast dich ganz einfach nur vertippt.
                </motion.p>
                <Link to={"/"}>
                    <button>Startseite</button>
                </Link>
            </div>
        </div>
    )
};

export default NotFound